
<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">
    <small>Se vuoi modificare solo le date, lascia il numero fattura invariato.</small>
    <div class="formgrid grid mt-5">
        <div class="field col-12 md:col-4">
            <label>Numero</label>
            <InputText v-model="item.numero"  type="text" :class="['inputfield w-full',{'p-invalid': validationErrors.numero && submitted}]" />
            <div v-show="validationErrors.numero && submitted" class="p-error">Lunghezza non valida.</div>
        </div>
        <div class="field col-12 md:col-4">
            <label>Data Emissione</label>
            <Calendar v-model="item.info.new_data_emissione"  dateFormat="dd-mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_emissione || validationErrors.data_before && submitted}]"  />
            <div v-show="validationErrors.data_emissione && submitted" class="p-error">Data non valida.</div>
            <div v-show="validationErrors.data_before && submitted" class="p-error">Data emissione non può essere successiva alla scadenza.</div>
        </div>
        <div class="field col-12 md:col-4">
            <label>Data Scadenza</label>
            <Calendar v-model="item.info.new_data_scadenza" dateFormat="dd-mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_scadenza && submitted}]"  />
            <div v-show="validationErrors.data_scadenza && submitted" class="p-error">Data non valida.</div>
        </div>
    </div>
    <div v-if="changed_numero" class="message">
      <p>Questo numero fattura {{old_invoice.numero}} non è piu disponibile perché è stato modificato</p>
       <router-link
          :to="`/ask/clienti/fatture/${item.numero}/dettagli`" target='_blank' 
        >
        <p class="link">Vai al nuovo numero {{item.numero}}</p>
        </router-link> 
    </div>
  </div>

  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import { ref, getCurrentInstance, onBeforeMount} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'fattura-modifica-dati'}
    const loader = ref(false)
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const item = ref({...props.data})
    const old_invoice = ref({});
    const changed_numero = ref(false)
    const validationErrors = ref({})
    const submitted = ref(false)
    onBeforeMount(() => {
      old_invoice.value = {...item.value}
      item.value.info.new_data_emissione = new Date(item.value.info.data_emissione)
      item.value.info.new_data_scadenza = new Date(item.value.info.data_scadenza)
    })
    
    
    const onOkButton = () => {
      
      submitted.value = true;
      toast.removeGroup(page.name);
      const obj = {}
      obj.id = item.value.info.idfattura
      obj.new_numero = item.value.numero;
      obj.old_numero = old_invoice.value.numero;
      obj.data_emissione = moment(item.value.info.new_data_emissione).format("YYYY-MM-DD")
      obj.data_scadenza = moment(item.value.info.new_data_scadenza).format("YYYY-MM-DD")
      if (validateForm(obj.new_numero, obj.data_emissione, obj.data_scadenza)) {
        loader.value = true
        service.editInvoice(obj)
        .then((res) =>{
          // console.log(res)
          if (res.item.success) {
            if (res.item.changed) {
              changed_numero.value = true
            } 
            toast.add({severity:'success', summary: 'Successo', detail:res.item.msg, group: page.name});
            
          } else {
            toast.add({severity:'warn', summary: 'Attenzione', detail:res.item.msg, group: page.name});
          }
        })
        .finally(()=>{
          loader.value = false    
        })
      }
    }
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }
    const validateForm = (numero, data_emissione, data_scadenza) => {
      if (numero.length > 7 && numero.length < 10) {
        delete validationErrors.value['numero'];
      } else {
        validationErrors.value['numero'] = true;
      }
      if (moment(data_emissione).isValid()) {
        delete validationErrors.value['data_emissione'];
      } else {
        validationErrors.value['data_emissione'] = true;
      }
      if (moment(data_scadenza).isValid()) {
        delete validationErrors.value['data_scadenza'];
      } else {
        validationErrors.value['data_scadenza'] = true;
      }
      if (moment(data_emissione).isValid() && moment(data_scadenza).isValid()) {
        if(moment(data_emissione).isBefore(moment(data_scadenza))){
          delete validationErrors.value['data_before'];
        } else {
          validationErrors.value['data_before'] = true;
        }
      }
      return !Object.keys(validationErrors.value).length;
    }
    return {
      page,
      item,
      old_invoice,
      changed_numero,
      loader,
      onCancelButton,
      onOkButton,
      submitted,
      validationErrors
    }
  }
}
</script>

<style scoped>
.message {
  margin-top: 30px;
  margin-top: 10px;
  background-color: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
}
.message .link {
    color: #2ca9f3;
}
</style>
